<div class="file-list-item-wrapper">
	<div class="file-description-wrapper">
		<div class="file-description">
			@if (!disableBulkSelections) {
				<mat-checkbox
					[disabled]="!fileData.pk"
					[class.checbox-disabled]="!fileData.pk"
					[checked]="isFileSelected"
					color="primary"
					class="au-checkbox"
					(change)="selectionChange($event.checked)"
				></mat-checkbox>
			}

			<au-file-name
				[fileData]="fileData"
				[fileTypesConfig]="fileTypesConfig"
				(openFile)="open()"
			></au-file-name>
		</div>

		<au-file-error-viewer
			class="error-viewer"
			[errors]="fileData.errors"
		></au-file-error-viewer>
	</div>

	@if (fileData.errors?.httpError) {
		<button
			(click)="retryLoading()"
			mat-icon-button
			type="button"
			class="file-action"
			matTooltip="{{ 'retry_loading' | translate }}"
		>
			<mat-icon svgIcon="refresh"></mat-icon>
		</button>
	}

	@if (showDeleteButton) {
		<button
			(click)="delete()"
			mat-icon-button
			type="button"
			class="file-action delete-action"
		>
			<mat-icon class="critical-icon" svgIcon="delete"></mat-icon>
		</button>
	}

	@if (showCancelButton) {
		<button
			(click)="cancel()"
			mat-icon-button
			type="button"
			class="file-action"
			matTooltip="{{ 'clear' | translate }}"
		>
			<mat-icon class="critical-icon" svgIcon="remove"></mat-icon>
		</button>
	}

	@if (fileData.loadingProgress > 0 && fileData.loadingProgress < 100) {
		<au-load-progress-bar
			class="loader-bar"
			[width]="fileData.loadingProgress"
		></au-load-progress-bar>
	}

	@if (deletionLoaderVisible) {
		<div class="spinner-wrapper">
			<mat-spinner diameter="20"></mat-spinner>
		</div>
	}
</div>
